export default __webpack_public_path__ + "static/media/wall-recessed.613273ab.svg";